import http from "./api";

export const userLogin = (data) =>
  new Promise((resolve, reject) =>
    http
      .post("/loginWeb", data)
      .then((res) => resolve(JSON.parse(res.data)))
      .catch((err) => reject(err))
  );
